import {MutationTree} from 'vuex';

import type {Translations} from '@/types';

import {State} from './state';
import {TranslationMutationTypes as MutationTypes} from './mutation-types';

export type Mutations<S = State> = {
    [MutationTypes.SET_TRANSLATIONS](state: S, payload: Translations): void;
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SET_TRANSLATIONS](state: State, payload: Translations) {
        Object.assign(state, payload)
    },
};